export default __webpack_public_path__ + "static/media/MapBackground.757909d6.webp";